import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dcn-error',
    templateUrl: './dcn-error.component.html',
    styleUrls: ['./dcn-error.component.scss'],
    standalone: false
})
export class DcnErrorComponent  implements OnInit {
  title="";
  message="";
  buttonCancel:boolean=false;
  constructor(
    public dialogRef: MatDialogRef<DcnErrorComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
      this.buttonCancel=false;
     this.dialogRef.disableClose = true;
     this.title=data.title;
     this.message=data.message;
     this.buttonCancel=data.buttonCancel===false?data.buttonCancel:false;
    }

  close(): void {
    this.dialogRef.close("No");
  }
 
  ngOnInit(): void {
   // this.canActivate();
  }

  yes(){
    this.dialogRef.close("Yes");
  }
    
  no(){
    this.dialogRef.close("No");
  }
  

}
